import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

export const DemandFlowStatusOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: ${theme.colors.background.default}d9;
    backdrop-filter: blur(4px);
    padding: ${theme.space[32]};
    overflow: auto;
`;
